export default __webpack_public_path__ + "static/media/river_of_ruin.04067489.svg";